// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__NNLS0","buttons":"Footer_buttons__2vnDN"};